import React from "react";
import {AiFillLinkedin} from 'react-icons/ai';
import {AiFillGithub} from 'react-icons/ai';
import {AiFillInstagram} from 'react-icons/ai';
import './landing.css';

function LandingSocials() {
    return (
        <div className="landing__socials">
            <a href="https://www.instagram.com/marwan_0sman/" target="_blank"><AiFillInstagram/></a>
            <a href="https://www.linkedin.com/in/marwan-osman-5b9b88209/" target="_blank"><AiFillLinkedin /></a>
            <a href="https://github.com/marwanosman505" target="_blank"><AiFillGithub/></a>
        </div>
    )
}

export default LandingSocials;